import React from 'react';
import { ImageListItemBar, Stack, Grid, Box, Typography, Button } from '@mui/material';

export default function BundleImagePicker({ bundle, onSelectImage }) {
    const [imageList, setImageList] = React.useState([]);

    React.useEffect(() => {
        const list = [];
        if (bundle.heroProduct?.medias) {
            list.push({
                key: 'HERO_IMAGE',
                thumbnailUrl: bundle.heroProduct.medias.thumbnailUrl,
                title: 'Hero Image',
                imageData: {
                    thumbnailUrl: bundle.heroProduct.medias.heroUrl,
                    heroUrl: bundle.heroProduct.heroUrl,
                },
            });
        }

        bundle.cards?.forEach((c) => {
            list.push({
                key: c.cardId,
                thumbnailUrl: c.cardImage.thumbnailUrl,
                title: c.cardName,
                imageData: c.cardImage,
            });
        });

        setImageList(list);
    }, [bundle]);

    return (
        <Stack direction="column" spacing={8}>
            <Box>
                <Typography variant="h3">Select primary image</Typography>
            </Box>
            {imageList.map((item) => (
                <Grid container key={item.key}>
                    <Grid xs={4}>
                        <img alt={item.title || ''} src={`${item.thumbnailUrl}`} loading="lazy" style={{ width: 120, height: 120 }} />
                    </Grid>
                    <Grid xs={7}>
                        <ImageListItemBar title={item.title} position="below" />
                    </Grid>
                    <Grid xs={1}>
                        <Button variant="contained" color="primary" onClick={() => onSelectImage(item.imageData)}>
                            Assign
                        </Button>
                    </Grid>
                </Grid>
            ))}
        </Stack>
    );
}
